import type { Translate } from "@/lib/i18n/translate";

/**
 * App-side view of the supported UI languages.
 *
 * The list itself lives in `@v1/backend/logic/i18n/locales` — a pure leaf module
 * shared with Convex, so the schema validator for `users.ui_language` and the
 * frontend can never disagree about which languages exist. Everything added
 * here is app-only plumbing (cookie, header, display labels) that the backend
 * has no business knowing.
 */

export {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  isSupportedLocale,
  toLocale,
} from "@v1/backend/logic/i18n/locales";
export type { Locale } from "@v1/backend/logic/i18n/locales";

import type { Locale } from "@v1/backend/logic/i18n/locales";

/** Cookie that carries the chosen locale so it applies before Convex loads. */
export const LOCALE_COOKIE_NAME = "NEXT_LOCALE";

/** Request header the middleware injects for server components to read. */
export const LOCALE_HEADER_NAME = "x-locale";

/** One year — the choice is a stable preference, not a session detail. */
export const LOCALE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

/**
 * Native language names. Shown in the switcher in the language itself, which is
 * why these stay in code rather than message files (identical in every catalog).
 */
export function localeLabels(t: Translate): Readonly<Record<Locale, string>> {
  return {
    de: t("deutsch"),
    en: t("english"),
  };
}

/**
 * BCP 47 tags for `Intl`. Machine ids, never translate. `en` is en-GB:
 * Europe-only product, so day-first dates.
 */
export function localeBcp47(t: Translate): Readonly<Record<Locale, string>> {
  return {
    de: t("deDe"),
    en: t("enGb"),
  };
}
